/* lg-banner-order.js - Stofind B2.5 (28 Aug, McKyle ruling): on sold-out
   PDPs the availability banner must sit BETWEEN the sold-out submit button and
   the app-injected LayUp band. LayUp mounts itself inside product-form via its
   own script, so Liquid order cannot achieve this; the banner renders in
   Liquid ABOVE the buy-buttons (B1) and this script relocates it after
   .product-form__buttons, then holds it there when LayUp mounts around it.
   JS-off degrades to B1 (banner above the button) - acceptable per ruling.

   Block 102 (10 Sep): the banner and the incoming-stock block are now one
   wrapper, #LgAvailability-<section>, and the wrapper is what moves. Two
   reasons. Moving loose siblings meant product-info.js could not swap their
   contents on a variant change without stranding whatever had been relocated;
   and the pill itself is per-variant, so a swap can now add or remove it, which
   the two-node version had no way to notice. Relocation is re-asserted on
   lg:variant-state, the event product-info.js fires after applying a swap. */
(function () {
  "use strict";
  var home = null;
  function relocate() {
    var wrap = document.querySelector(".lg-availability");
    if (!wrap || !wrap.parentElement) return false;
    /* Remember where Liquid put it, once, so a variant that drops the pill can
       be put back rather than left floating inside the form. */
    if (!home) { home = document.createComment("lg-availability-home"); wrap.parentElement.insertBefore(home, wrap); }
    var banner = wrap.querySelector(".lg-store-availability-banner");
    var buttons = document.querySelector(".product-form__buttons");
    if (banner && buttons && buttons.parentElement) {
      if (wrap.previousElementSibling !== buttons) buttons.parentElement.insertBefore(wrap, buttons.nextSibling);
    } else if (wrap.previousSibling !== home) {
      home.parentNode.insertBefore(wrap, home.nextSibling);
    }
    return true;
  }
  function start() {
    if (!relocate()) return; // not a PDP
    document.addEventListener("lg:variant-state", relocate);
    var buttons = document.querySelector(".product-form__buttons");
    if (!buttons || !buttons.parentElement) return;
    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return; // at most one re-assert per mutation batch
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; relocate(); });
    });
    mo.observe(buttons.parentElement, { childList: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else { start(); }
})();
